import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'browser-restriction-page',
  templateUrl: './browser-restriction-page.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule],
})
export class BrowserRestrictionPageComponent implements OnInit {
  @Output() isBrowserPermittedEmitter = new EventEmitter(false);
  isChromeOrSafari: boolean | undefined = undefined;

  ngOnInit(): void {
    this.checkBrowser();
  }

  checkBrowser(): void {
    const userAgent = navigator.userAgent.toLowerCase();
    const isChrome = userAgent.indexOf('chrome') > -1 && userAgent.indexOf('edge') === -1 && userAgent.indexOf('edg') === -1;
    const isSafari = userAgent.indexOf('safari') > -1 && userAgent.indexOf('chrome') === -1;
    this.isChromeOrSafari = isChrome || isSafari;
    this.isBrowserPermittedEmitter.emit(this.isChromeOrSafari);
  }
}
